import { Permission } from "./permission";

 
export class MenuItems {
        
        public menuItemId : number;
        public nameItem : string ; 
        public iconNameItem: string ;  
        public noEntryItem: boolean ; 
        public pathItem : string;
        public menuItemParentId : number;
        public children: MenuItems[] ; 
        public flgEmployeeType :boolean;
        public level : number;
        public isMenuOption: boolean ;
        public isLeaf : boolean;
        public isVisible : boolean;  
        public permission : Permission[];
}



// WEBPACK FOOTER //
// ./src/app/core/model/menu-items.ts